<template>
  <el-button-separate
    :class="classP"
    icon="mdi-plus"
    :disabled="disabled"
    :loading="loading"
    :primary="primary"
    :small="small"
    :x-small="xSmall"
  >
    <template v-if="isSlot">
      <slot></slot>
    </template>
    <template v-else>
      Pridėti
    </template>
  </el-button-separate>
</template>

<script>
export default {
  name: 'ElButtonPrideti',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
    primary: Boolean,
    small: Boolean,
    xSmall: Boolean,
  },
  computed: {
    isSlot() {
      return !!this.$slots.default
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
